module.exports = jQuery.validate;